import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export const useSectionOrders = (pageType: string) => {
  return useQuery({
    queryKey: ['section-orders', pageType],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('section_orders')
        .select('*')
        .eq('page_type', pageType)
        .eq('is_active', true)
        .order('position', { ascending: true });
      
      if (error) throw error;
      return data || [];
    },
    staleTime: 30 * 60 * 1000, // Very stable
    gcTime: 60 * 60 * 1000,
    enabled: !!pageType,
  });
};
